import React, { useEffect, useState } from 'react';
import { Space, Table, Tag, Card, Select, notification, Flex } from 'antd';

import { Button, Checkbox, Form, Input, Modal } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ProductService from 'services/product';
import { useParams, useNavigate } from "react-router"
import { useForm, useWatch } from "antd/es/form/Form";
import ProductOptionService from 'services/product_option'
import ProductVariantService from 'services/product_variant'
import InputNumber from "components/input-number"
import { formatCurrency } from "utils/number"
const service = new ProductService();
const productOptionService = new ProductOptionService();
const productVariantService = new ProductVariantService();

const AddNewProductPage = () => {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const [options, setOptions] = useState([])
  const [productOptions, setProductOptions] = useState([]);
  const [productVariants, setProductVariants] = useState([])
  const [selectedOption, setSelectedOption] = useState(null)
  const [api, contextHolder] = notification.useNotification();
  const [product, setProduct] = useState({})
  const onFinish = async (values) => {
    if (id) {
      var created = await service.updateGeneralInfo(values);
      navigate(`/product/edit/${id}`);

    } else {
      var created = await service.create(values);
      navigate(`/product/edit/${created.id}`);
    }

    console.log('Success:', created);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {

  }, [])

  useEffect(() => {
    if (id) {
      loadData();
    }
  }, [id])

  useEffect(() => {
    // createProductVariants();
  }, [options])

  const loadData = async () => {
    setProduct({});
    var item = await service.get(id);
    setProduct(item);
    setProductVariants(item.variants);

  }





  const onUpdateProductVariantPriceList = async () => {


    await productVariantService.updatePriceList({ variants: productVariants });

    api.success({ description: "Đã cập nhật" })

  }

  const onVariantPriceListChange = (price_list, variant_id) => {

    var i = productVariants.findIndex(x => x.variant_id == variant_id);
    var newVariants = [...productVariants];
    newVariants[i].price_list = price_list;
    setProductVariants(newVariants);
  }

  const onVariantOriginalPriceChange = (original_price, variant_id) => {

    var i = productVariants.findIndex(x => x.variant_id == variant_id);
    var newVariants = [...productVariants];
    newVariants[i].original_price = original_price;
    setProductVariants(newVariants);
  }





  return (

    <div>
      {contextHolder}
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Card size="small" title={"Giá sản phẩm"} style={{ width: "100%" }}>

          <div style={{ marginTop: 16 }}>
            <Table pagination={false} dataSource={productVariants} columns={[
              {
                title: 'Biến thể',
                dataIndex: 'variant_title',
                key: 'name',
              },

              {
                title: 'Giá bán',
                render: (_, { original_price, variant_id }) => {
                  return (
                    <div>
                      {formatCurrency(original_price)}
                      {/* <InputNumber value={original_price}></InputNumber> */}

                      <PriceOriginalEdit value={original_price ?? 0} onChange={e => onVariantOriginalPriceChange(e, variant_id,)}></PriceOriginalEdit>
                    </div>
                  )
                }
              },

              {
                title: 'Giá theo số lượng',
                render: (_, { price_list = [], variant_id, original_price }) => {
                  return (
                    <div>

                      {price_list.map(x => {
                        return (
                          <div style={{ display: "flex" }}>
                            <div style={{ width: 75 }}>
                              Từ {x.min}
                            </div>
                            <div style={{ width: 75 }}>
                              <b>{formatCurrency(x.price)}</b>
                            </div>
                            <div style={{ marginLeft: 16 }}>Giảm {formatCurrency((x.price - original_price) * -1)}</div>
                          </div>
                        )
                      })}



                      <PriceEdit value={price_list ?? []} original_price={original_price} onChange={e => onVariantPriceListChange(e, variant_id,)} ></PriceEdit>


                    </div>
                  )
                }
              },


              // {
              //   title: 'Giá',
              //   render: (_, { images, variant_id }) => {
              //     return (
              //       <div>
              //         <Button type='link'>sửa </Button>

              //       </div>
              //     )
              //   }
              // },


            ]} />
          </div>
          <div style={{ marginTop: 32 }}>
            <Flex justify='flex-end'>
              <Space>
                <Button type='default' onClick={e => navigate(`/product/edit/${id}`)} >Back</Button>
                <Button type='primary' onClick={onUpdateProductVariantPriceList} >Cập nhật</Button>

              </Space>
            </Flex>

          </div>

        </Card>



      </Space>
    </div>

  )
};

const PriceEdit = ({ value = [], onChange, original_price = 0 }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pricelist, setPriceList] = useState([])
  useEffect(() => {
    setPriceList([...value])
  }, [value])
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    onChange(pricelist)
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onAddPrice = () => {
    if (pricelist.length > 0) {
      var last = pricelist[pricelist.length - 1];
      var newPrices = { min: last.max, max: last.max + 10, price: last.price - 10000 };
      var newPriceList = [...pricelist, newPrices];
      setPriceList(newPriceList);
    } else {

      var newPrices = { min: 1, max: 5, price: original_price };
      var newPriceList = [...pricelist, newPrices];
      setPriceList(newPriceList);
    }

  }

  const deletePriceAt = (i) => {
    var newPriceList = [...pricelist];
    newPriceList.splice(i, 1);
    setPriceList(newPriceList);
  }

  const updatePriceAt = (i, name, value) => {
    var newPriceList = [...pricelist];
    newPriceList[i][name] = value;
    setPriceList(newPriceList);
  }
  return (
    <div>


      <Space direction='vertical'>

        <Button type='link' onClick={showModal}>Sửa</Button>
      </Space>

      <Modal title="Sửa giá" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
        footer={<Space>

          <Button type='primary' onClick={onAddPrice}>Thêm khoảng</Button>
          <Button type='primary' onClick={handleOk}>Ok</Button>
        </Space>}
      >
        <Table pagination={false} dataSource={pricelist} columns={[
          {
            title: 'Từ',
            render: (_, { min, max }, i) => {
              return (
                <Space>

                  <InputNumber value={min} onChange={e => updatePriceAt(i, "min", e)} showCalculator={false}></InputNumber>
                  {/* đến
                  <InputNumber value={max} onChange={e => updatePriceAt(i, "max", e)} ></InputNumber> */}


                </Space>
              )
            }
          },

          {
            title: 'Giá',
            render: (_, { price }, i) => {
              return (
                <div>
                  <InputNumber value={price} onChange={e => updatePriceAt(i, "price", e)}></InputNumber>

                </div>
              )
            }
          },


          {
            title: '',
            render: (_, { images, variant_id }, index) => {
              return (
                <div>
                  <Button type='link' onClick={e => deletePriceAt(index)} >Xoá </Button>

                </div>
              )
            }
          },


        ]} />

      </Modal>
    </div>



  )


}



const PriceOriginalEdit = ({ value = 0, onChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [price, setPrice] = useState(0)
  useEffect(() => {
    setPrice(value)
  }, [value])
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    onChange(price)
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };


  return (
    <div>


      <Space direction='vertical'>







        <Button type='link' onClick={showModal}>Sửa</Button>
      </Space>

      <Modal title="Sửa giá" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
        footer={<Space>

          <Button type='primary' onClick={handleOk}>Ok</Button>
        </Space>}
      >
        <InputNumber value={price} onChange={e => setPrice(e)}></InputNumber>

      </Modal>
    </div>



  )


}



export default AddNewProductPage;